import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Row, Col, Select, DatePicker } from "antd";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import moment from "moment";
import Request from "../../request";
import { TableComp } from "sz-react-utils";

const { Option } = Select;
const { MonthPicker } = DatePicker;

var totalCurrentData = null;

class CounsellingConversionReport extends Component {
  state = {
    lastSixYears: [],
    dateFilter: null,
    dateKeys: null,
    data: null,
    loading: false,
    counsellorsArr: [],
    counsellorId: null,
    year: null
  };

  loadCounsellors = async () => {
    let { data } = await Request.loadAllCounsellors();
    this.setState({ counsellorsArr: data })
  }

  // Fetch counsellor data

  // Transform counsellors data for TableComp
  prepareTableData = (counsellors) => {
    return Object.values(counsellors).map((item) => ({
      key: item.counsellorId, // Unique key for the table
      counsellorDetails: item.counsellorDetails,
      counsellingCount: item.counsellingCount,
      registrationCount: item.registrationCount,
      conversionRatio: item.counsellingCount
        ? ((item.registrationCount / item.counsellingCount) * 100).toFixed(2) + "%" // Calculate percentage
        : "0.00%", // Handle cases where counsellingCount is 0
    }));
  };

  componentDidMount() {
    this.loadCounsellors();
    const currentYear = new Date().getFullYear();
    const lastSixYears = Array.from({ length: 6 }, (_, i) => currentYear - i);
    this.setState({ lastSixYears });
  }

  // Fetch API data based on date filters
  loadApi = async () => {
    this.setState({ loading: true });
    let params = {};
    if (this.state.dateFilter) {
      params.dateFilter = this.state.dateFilter;
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId
      }
      try {
        let response = await Request.getCounsellingConversionReport(params);
        const dateKeys = Object.keys(response.data);
        this.setState({ dateKeys, data: response.data });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      this.setState({ loading: false });
    }
  };

  // Handle date filter changes
  handleDateChange = (value, filterName) => {
    let dateFilter = null;
    let { year } = this.state;
    // Filter by Year
    if (filterName === "year") {
      dateFilter = {
        $gte: moment(value, "YYYY").startOf("year").toDate(),
        $lte: moment(value, "YYYY").endOf("year").toDate(),
      };
    }

    // Filter by Half Year
    if (filterName === "halfYear") {
      if (value === "First Half Year") {
        dateFilter = {
          $gte: year
            ? moment(year, "YYYY").startOf("year").toDate()
            : moment().startOf("year").toDate(),
          $lte: year
            ? moment(year, "YYYY")
              .startOf("year")
              .add(5, "months")
              .endOf("month")
              .toDate()
            : moment()
              .startOf("year")
              .add(5, "months")
              .endOf("month")
              .toDate(),
        };
        // dateFilter = {
        //   $gte: moment().startOf("year").toDate(),
        //   $lte: moment().startOf("year").add(5, "months").endOf("month").toDate(),
        // };
      } else if (value === "Second Half Year") {
        dateFilter = {
          $gte: year
            ? moment(year, "YYYY")
              .startOf("year")
              .add(6, "months")
              .toDate()
            : moment()
              .startOf("year")
              .add(6, "months")
              .toDate(),
          $lte: year
            ? moment(year, "YYYY").endOf("year").toDate()
            : moment().endOf("year").toDate(),
        };
        // dateFilter = {
        //   $gte: moment().startOf("year").add(6, "months").toDate(),
        //   $lte: moment().endOf("year").toDate(),
        // };
      }
    }

    // Filter by Quarter
    if (filterName === "quarter") {
      const startOfQuarterMap = {
        "First Quarter": 0,
        "Second Quarter": 3,
        "Third Quarter": 6,
        "Fourth Quarter": 9,
      };
      if (value) {
        const startMonth = startOfQuarterMap[value];
        dateFilter = {
          $gte: year
            ? moment(year, "YYYY")
              .startOf("year")
              .add(startMonth, "months")
              .toDate()
            : moment()
              .startOf("year")
              .add(startMonth, "months")
              .toDate(),
          $lte: year
            ? moment(year, "YYYY")
              .startOf("year")
              .add(startMonth + 2, "months")
              .endOf("month")
              .toDate()
            : moment()
              .startOf("year")
              .add(startMonth + 2, "months")
              .endOf("month")
              .toDate(),
        };
        // dateFilter = {
        //   $gte: moment().startOf("year").add(startMonth, "months").toDate(),
        //   $lte: moment()
        //     .startOf("year")
        //     .add(startMonth + 2, "months")
        //     .endOf("month")
        //     .toDate(),
        // };
      }
    }

    // Filter by Month
    if (filterName === "month") {
      dateFilter = {
        $gte: moment(value, "YYYY-MM").startOf("month").toDate(),
        $lte: moment(value, "YYYY-MM").endOf("month").toDate(),
      };
    }

    // Reset date filter
    if (value === null) {
      dateFilter = null;
    }

    this.setState({ dateFilter }, () => {
      this.loadApi();
    });
  };

  render() {
    const { lastSixYears, dateFilter, dateKeys, data, counsellorsArr } = this.state;

    const columns = [
      {
        title: "Counsellor Name",
        dataIndex: "counsellorDetails",
        key: "counsellorDetails",
      },
      {
        title: `Counselling Count`,
        dataIndex: "counsellingCount",
        key: "counsellingCount",
      },
      {
        title: `Registration Count`,
        dataIndex: "registrationCount",
        key: "registrationCount",
      },
      {
        title: `Conversion Ratio`,
        dataIndex: 'conversionRatio',
        key: 'conversionRatio'
      }
    ];

    // Sort dateKeys chronologically
    const sortedDateKeys = dateKeys
      ? dateKeys.sort((a, b) => moment(a).valueOf() - moment(b).valueOf())
      : [];

    return (
      <PageHeaderWrapper title="Counselling & Conversion Report">
        {/* Card for Date Filter */}
        <Card bordered={true}>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label>Search By Year</label>
              <Select
                style={{ width: "100%" }}
                placeholder="Select year"
                onChange={(value) => this.setState({ year: value }, () => { this.handleDateChange(value, "year") })}
              // onChange={(value) => this.handleDateChange(value, "year")}
              >
                {lastSixYears.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={6}>
              <label>Search By Half Yearly</label>
              <Select
                style={{ width: "100%" }}
                placeholder="Select half year"
                onChange={(value) => this.handleDateChange(value, "halfYear")}
              >
                <Option value="First Half Year">First Half Year</Option>
                <Option value="Second Half Year">Second Half Year</Option>
              </Select>
            </Col>
            <Col span={6}>
              <label>Search By Quarter</label>
              <Select
                style={{ width: "100%" }}
                placeholder="Select quarter"
                onChange={(value) => this.handleDateChange(value, "quarter")}
              >
                <Option value="First Quarter">First Quarter</Option>
                <Option value="Second Quarter">Second Quarter</Option>
                <Option value="Third Quarter">Third Quarter</Option>
                <Option value="Fourth Quarter">Fourth Quarter</Option>
              </Select>
            </Col>
            <Col span={6}>
              <label>Search By Month</label>
              <MonthPicker
                style={{ width: "100%" }}
                placeholder="Select month"
                onChange={(date) => this.handleDateChange(date, "month")}
              />
            </Col>
          </Row>
        </Card>
        {/* Search By Counsellor */}
        {dateFilter ?
          <Card>
            <Row gutter={16}>
              <Col span={6}>
                <label>Search By Counsellor</label>
                <Select
                  style={{ width: "100%" }}
                  showSearch
                  placeholder="Select Counsellor"
                  onChange={(value) => this.setState({ counsellorId: value }, () => {
                    this.loadApi()
                  })}
                >
                  {counsellorsArr.map((counsellor) => (
                    <Option key={counsellor._id} value={counsellor._id}>
                      {counsellor.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Card>
          : null}
        {/* Card for Counsellor Table */}
        {dateFilter && (
          <Card bordered={true} style={{ marginTop: 10 }} loading={this.state.loading}>
            {sortedDateKeys.map((dateKey) => {
              const currentData = data[dateKey];
              const tableData = this.prepareTableData(currentData.counsellors);
              totalCurrentData = currentData;
              return (
                <Card
                  key={dateKey}
                  title={`Data for ${moment(currentData.date).format("MMM YYYY")}`}
                  style={{ marginBottom: "20px" }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p>
                      <strong>Counsellings:</strong> {currentData.inquiriesCount}
                    </p>
                    <p>
                      <strong>Registrations:</strong> {currentData.registrationsCount}
                    </p>
                    <p>
                      <strong>Conversion Ratio:</strong> {currentData.registrationsCount && currentData.inquiriesCount ? ((currentData.registrationsCount / currentData.inquiriesCount) * 100).toFixed(2) + "%" : "0.00%"}
                    </p>
                  </div>
                  <TableComp
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    bordered
                  />
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Total Counsellings</th>
                        <th>Total Registrations</th>
                        <th>Conversion Ratio</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{currentData.inquiriesCount}</td>
                        <td>{currentData.registrationsCount}</td>
                        <td>{currentData.registrationsCount && currentData.inquiriesCount ?
                          ((currentData.registrationsCount / currentData.inquiriesCount) * 100).toFixed(2) + "%"
                          : "0.00%"}</td>
                      </tr>
                    </tbody>
                  </table>
                </Card>
              );
            })}
          </Card>
        )}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
});

export default connect(mapStateToProps)(CounsellingConversionReport);
